export default {
    book: 'Резервишите {product}',
    age_limit: 'Само преко {age}',
    change_plan: "Промени план",
    upgrade_product: 'Надоградите производ',
    upgrade: "Mejora",
    cancel_upgrade: "Cancelar actualización",
    choose_product: 'Одаберите {product}',
    days: '{count} дан | {count} дана',
    login_register: "Пријава/Регистрација",
    current: "Тренутни",
    keyless_benefits: {
        label: 'Право до аутомобила {0}',
        highlight: 'услуга изнајмљивања™',
        list: {
            cant_lose_the_key: 'Пуно осигурање',
            zero_excess: 'Нула вишка',
            phone_as_a_key: 'Телефон као кључ',
            straight_to_car: 'Нема чекања',
            no_queues: 'Нема редова',
            online_id_check: 'Провера ИД-а на мрежи',
            self_checkout: 'Селф Цхецкоут',
        },
    },
}
